import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Leaf, Recycle, HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ImpactBlock = ({ impact, className }) => {
  if (!impact) return null;

  return (
    <div className={cn("bg-wool-sage-light rounded-xl p-6", className)}>
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 bg-accent rounded-lg">
          <Leaf className="h-5 w-5 text-accent-foreground" />
        </div>
        <h3 className="font-display text-lg font-medium text-foreground">Environmental Impact</h3>
      </div>

      <div className="space-y-4">
        {/* Waste Addressed */}
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Recycle className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm font-medium text-foreground">Waste Addressed</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {impact.wasteAddressed}
          </p>
        </div>

        {/* Impact Metric */}
        <div className="flex items-center justify-between bg-background/60 rounded-lg p-4">
          <div>
            <span className="text-sm text-muted-foreground">Impact</span>
            <p className="text-xl font-display font-semibold text-foreground">
              {impact.metric}
            </p>
          </div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors">
                  <HelpCircle className="h-3.5 w-3.5" />
                  <span>How we estimate this</span>
                </button>
              </TooltipTrigger>
              <TooltipContent side="top" className="max-w-xs">
                <p className="text-sm">{impact.methodology}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        {/* Badge */}
        <Badge variant="secondary" className="bg-background/60 text-foreground border-0">
          <Leaf className="h-3 w-3 mr-1" />
          Verified Impact
        </Badge>
      </div>
    </div>
  );
};
